import {
  UserMemberCreated,
  UserMemberPost,
  UserMemberProfileDTO,
  UserMemberSignupDTO,
} from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";
import { trimFields } from "./features/trimFiels";

export type PublicUserMemberApiType = ReturnType<typeof publicUserMemberApi>;

const publicUserMemberApi = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const fieldsToTrim = [
    "firstName",
    "lastName",
    "mobileNumber",
    "dateBirth",
    "postCode",
    "addressLine1",
    "addressLine2",
    "city",
    "email",
    "emergencyContact",
    "emergencyContactName",
    "username",
  ];
  const axiosInstance = createAxiosInstance({
    apiUrl,
  });

  return {
    create(newResource: UserMemberPost) {
      return axiosInstance.post<{ userMember: UserMemberCreated }>(
        `${clubPrefix}hosted/user/member`,
        trimFields(newResource, fieldsToTrim),
      );
    },

    emailExists(email: string) {
      return axiosInstance.get<boolean>(
        `${clubPrefix}hosted/catalog/user/email/check`,
        {
          params: { q: email.toLowerCase() },
        },
      );
    },

    verifyPaymentMethodLink: (paymentMethodId: string) =>
      `${axiosInstance.defaults.baseURL}/${clubPrefix}stripe-verify/${paymentMethodId}`,

    createAccount(values: UserMemberSignupDTO) {
      return axiosInstance.post<UserMemberProfileDTO>(
        `${clubPrefix}hosted/user-member-signup`,
        values,
      );
    },
  };
};

export default publicUserMemberApi;
